import React  from 'react';
import {
    RichCell,
    PanelHeader,
    Cell,
    PanelHeaderButton,
    Div,
    SplitCol,
    SplitLayout,
    Button,
    Switch, Spinner, Pagination, Search
} from '@vkontakte/vkui';
import axios from "axios";
import {addDays} from "@vkontakte/vkui/dist/lib/date";
import {
    AdaptivityContext, inducement
} from "../assets/constants";
import moment from "moment";
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import * as constants from "../assets/constants";
import {
    Icon24PicturePlusOutline,
    Icon24Search
} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';


class IncomingDocsViewer extends React.Component {


    constructor(props) {


        super(props);

    }

    render() {

        return (
            <SplitLayout>
                <SplitCol>
                    {Object.keys(this.props.items).map( (key, index) => {
                        const item = this.props.items[key]
                        return [<RichCell multiline
                                   subhead={item.date + ' ' + item.time}
                                   bottom={item.klient.title}
                                   caption={item.sclad.title}
                                   after={(item.summ * 1).toFixed(2)}
                                   afterCaption={[item.items_cnt, ' ', inducement(item.items_cnt, 'позиция', 'позиции', 'позиций')]}
                        >
                            {item.nomerDoc}
                        </RichCell>,

                            <hr/>]
                    })}
                </SplitCol>
            </SplitLayout>
        )
    }


}

export default IncomingDocsViewer